import React from 'react';
import { ActivityIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTASection() {
  return <section aria-labelledby="final-cta-title" className="bg-brand-primary px-4 py-24 text-center text-white" data-id="element-74" data-mp="3n4wco9ljutno">
      <Reveal className="mx-auto max-w-3xl" data-id="element-75" data-mp="welbgh1x51d">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-white/12 text-brand-yellow" data-id="element-76" data-mp="v3ibivfk1bb">
          <ActivityIcon className="h-7 w-7" aria-hidden="true" data-id="element-77" data-mp="2zbnxukwhaxwi" />
        </div>
        <h2 id="final-cta-title" className="mx-auto mt-6 max-w-2xl text-3xl font-extrabold tracking-tight md:text-5xl" data-id="element-78" data-mp="34cv3adb5fl00">
          Pronto/a a Portare il Movimento in Ogni Classe?
        </h2>
        <p className="mx-auto mt-5 max-w-xl leading-relaxed text-white/75" data-id="element-79" data-mp="3e3y4rg7zq1zt">
          Unisciti agli insegnanti che stanno già trasformando le loro lezioni di motoria.
        </p>
        <CTAButton className="mt-9 w-full max-w-md" data-id="element-80" data-mp="2ll2dssvaghx1" />
        <p className="mt-4 text-[11px] font-semibold text-white" data-id="element-81" data-mp="26v0zv2l2b23u">
          ✓ Pagamento unico <span className="px-1.5 text-brand-yellow" data-id="element-82" data-mp="26x3l79b9s728">·</span> ✓ Accesso immediato
          <span className="px-1.5 text-brand-yellow" data-id="element-83" data-mp="21wfw4t6lq0an">·</span> ✓ Garanzia 30 giorni
        </p>
      </Reveal>
    </section>;
}